import { Stack, Box, Title, Group, Text, Timeline } from '@mantine/core';
import { useLoans } from '@/hooks/use-loans';
import { formatCurrency } from '@/utils/formatters';
import styles from './parsing-results.module.css';

export function LoanDetailsPanel() {
  const { selectedLoan, selectedLoanEvents, isMobile } = useLoans();

  return (
    <Stack h="100%" gap="md">
      {/* Fixed header */}
      <Box px="xs" pb="md" style={{ borderBottom: '1px solid var(--mantine-color-gray-7)' }}>
        {!isMobile && (
          <Title order={6} mb="sm">
            Loan history
          </Title>
        )}
        {selectedLoan && (
          <Stack gap={0}>
            <Group justify="space-between" w="100%" align="flex-start">
              <Text size="sm" fw={500} style={{ flex: 1, minWidth: 0, wordBreak: 'break-word' }}>
                {selectedLoan['Loan Type Description'] || 'Unknown type'}
              </Text>
              <Text size="sm" fw={700} style={{ whiteSpace: 'nowrap' }}>
                {formatCurrency(selectedLoan['Total Outstanding'])}
              </Text>
            </Group>
            <Text size="sm" c="dimmed">
              Servicer: {selectedLoan['Loan Contact Name']}
            </Text>
            <Text size="sm" c="dimmed">
              School: {selectedLoan['Loan Attending School Name']}
            </Text>
          </Stack>
        )}
      </Box>

      {/* Scrollable timeline container */}
      <Box
        className={styles.timelineContainer}
        style={{
          flex: 1,
          overflowY: 'auto',
          scrollbarWidth: 'thin',
          scrollbarGutter: 'stable',
        }}
        pl="xs"
        pr="md"
        pt={0}
      >
        {selectedLoan ? (
          selectedLoanEvents.length > 0 ? (
            <Timeline active={selectedLoanEvents.length - 1} bulletSize={16} lineWidth={2}>
              {selectedLoanEvents.map((event, eventIndex) => (
                <Timeline.Item
                  key={`${String(eventIndex)}-${event['Loan Status Effective Date'] ?? 'nodate'}`}
                  title={
                    <Group justify="space-between" w="100%" align="flex-start">
                      <Text size="sm" style={{ flex: 1, minWidth: 0 }}>
                        {event['Loan Status Description'] || 'Status changed'}
                      </Text>
                      <Text size="sm" c="dimmed">
                        {event['Loan Status Effective Date'] || 'N/A'}
                      </Text>
                    </Group>
                  }
                ></Timeline.Item>
              ))}
            </Timeline>
          ) : (
            <Text c="dimmed" size="sm" ta="center" py="lg">
              No history available
            </Text>
          )
        ) : (
          <Text c="dimmed" ta="center" py="lg">
            Select a loan to view its timeline
          </Text>
        )}
      </Box>
    </Stack>
  );
}
